// extracted by mini-css-extract-plugin
module.exports = {"select":"SortingOptions_select__rQogY"};